export default __webpack_public_path__ + "static/media/Book_Akhanake.e1bd94a5.ttf";